import {
  Box,
  ContentIndex,
  ContentIndexContext,
  Grid,
  HotTopicBanner,
  theme,
} from '@zappyrent/hundop';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import React from 'react';
import Media from 'react-media';

import Layout from '../Layout';
import {
  StyledArticle,
  StyledButtonHolder,
  StyledContainer,
  StyledCtaButton,
  StyledH1,
  StyledH2,
  StyledHeaderSection,
} from './TextPageLandlord.styles';
import { ITextPageLandlordProps } from './TextPageLandlord.types';

const TextPage = ({
  articleId,
  h1Text,
  h2Text,
  contentIndexContextValue,
  contentIndexItems,
  children,
}: ITextPageLandlordProps): JSX.Element => {
  const { t } = useTranslation(['product']);

  return (
    <Layout
      superHeader={
        <HotTopicBanner
          backgroundColor={theme.colors.landlord.main}
          ctaLabel={t('product:rentWithUs')}
          ctaUrl={`${process.env.GATSBY_SITE_URL}/it/pubblica-annuncio-gratis`}
          firstLabel={t('product:areYouALandlord')}
          secondLabel={t('product:weAlwaysGuaranteeThePaymentOfTheRent')}
        />
      }
      user="landlord"
    >
      <StyledArticle id={articleId}>
        <Grid container>
          <StyledHeaderSection>
            <Box lg={6}>
              <StyledH1 tag="h1" sm="32px" md="32px" lg="56px">
                {h1Text}
              </StyledH1>
            </Box>
            <Box lg={4}>
              <StyledH2 tag="strong">{h2Text}</StyledH2>
            </Box>
            <Media
              queries={{
                mobile: `(max-width: calc(${theme.breakpoints.l} - 1px))`,
                desktop: `(min-width: ${theme.breakpoints.l})`,
              }}
              defaultMatches={{ desktop: true }}
            >
              {matches => (
                <>
                  {matches.desktop && (
                    <Box lg={2}>
                      <StyledCtaButton
                        href={`${process.env.GATSBY_SITE_URL}/it/pubblica-annuncio-gratis`}
                        tag="a"
                        title="Pubblica un Annuncio"
                      >
                        Pubblica un annuncio
                      </StyledCtaButton>
                    </Box>
                  )}
                </>
              )}
            </Media>
          </StyledHeaderSection>
        </Grid>
        <Media
          queries={{
            mobile: `(max-width: calc(${theme.breakpoints.l} - 1px))`,
            desktop: `(min-width: ${theme.breakpoints.l})`,
          }}
          defaultMatches={{ desktop: true }}
        >
          {matches => (
            <>
              {matches.mobile && (
                <ContentIndexContext.Provider value={contentIndexContextValue}>
                  <ContentIndex
                    items={contentIndexItems}
                    href={`${process.env.GATSBY_SITE_URL}/it/pubblica-annuncio-gratis`}
                    linkText="Pubblica un annuncio"
                    user="landlord"
                    threshold={380}
                  />
                  <Grid container>{children}</Grid>
                </ContentIndexContext.Provider>
              )}

              {matches.desktop && (
                <Grid container>
                  <StyledContainer>
                    <ContentIndexContext.Provider
                      value={contentIndexContextValue}
                    >
                      <Box lg={2}>
                        <ContentIndex
                          items={contentIndexItems}
                          href={`${process.env.GATSBY_SITE_URL}/it/pubblica-annuncio-gratis`}
                          linkText="Pubblica un annuncio"
                          user="landlord"
                          threshold={100}
                        />
                      </Box>
                      <Box lg={4}>{children}</Box>
                    </ContentIndexContext.Provider>
                  </StyledContainer>
                </Grid>
              )}
            </>
          )}
        </Media>
      </StyledArticle>
      <Media
        queries={{
          mobile: `(max-width: calc(${theme.breakpoints.l} - 1px))`,
          desktop: `(min-width: ${theme.breakpoints.l})`,
        }}
        defaultMatches={{ desktop: true }}
      >
        {matches => (
          <>
            {matches.mobile && (
              <StyledButtonHolder>
                <StyledCtaButton
                  href={`${process.env.GATSBY_SITE_URL}/it/pubblica-annuncio-gratis`}
                  tag="a"
                  title="Pubblica un Annuncio"
                >
                  Pubblica un annuncio
                </StyledCtaButton>
              </StyledButtonHolder>
            )}
          </>
        )}
      </Media>
    </Layout>
  );
};

export default TextPage;
